export enum TimeCardDataSourceType {
  Reported = "Reported",
  Planned = "Planned",
  ActualTracking = "ActualTracking",
  PassiveTracking = "PassiveTracking"
}

